
export const petCategories = [
  { id: 'all', name: 'All Pets', icon: 'ri-apps-line', color: '#9B4C9A' },
  { id: 'dog', name: 'Dogs', icon: 'ri-bear-smile-line', color: '#E8734A' },
  { id: 'puppies', name: 'Puppies', icon: 'ri-emotion-happy-line', color: '#F5A623' },
  { id: 'cat', name: 'Cats', icon: 'ri-ghost-smile-line', color: '#7B61FF' },
  { id: 'rabbit', name: 'Rabbits', icon: 'ri-leaf-line', color: '#4CAF50' },
  { id: 'birds', name: 'Birds', icon: 'ri-twitter-line', color: '#29B6F6' },
  { id: 'turtle', name: 'Turtles', icon: 'ri-shield-line', color: '#26A69A' },
];

export const petListings = [
  {
    id: 1,
    name: 'Max',
    category: 'dog',
    breed: 'Golden Retriever',
    age: '3 years',
    gender: 'Male',
    price: 850,
    location: 'Los Angeles, CA',
    description: 'Friendly and well-trained Golden Retriever. Great with kids and other pets. Fully vaccinated and microchipped.',
    image: 'https://public.readdy.ai/ai/img_res/63c54446401f67c3dca87e6a97cd11ee.jpg',
    seller: 'Happy Paws Kennel',
    featured: true,
  },
  {
    id: 2,
    name: 'Bella',
    category: 'dog',
    breed: 'French Bulldog',
    age: '2 years',
    gender: 'Female',
    price: 1200,
    location: 'New York, NY',
    description: 'Adorable French Bulldog with a playful personality. AKC registered with full health clearance.',
    image: 'https://readdy.ai/api/search-image?query=cute%20french%20bulldog%20sitting%20on%20soft%20cushion%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20adorable%20expression&width=600&height=600&seq=pet-dog2&orientation=squarish',
    seller: 'Elite Frenchies',
    featured: false,
  },
  {
    id: 3,
    name: 'Charlie',
    category: 'puppies',
    breed: 'Labrador Puppy',
    age: '8 weeks',
    gender: 'Male',
    price: 950,
    location: 'Chicago, IL',
    description: 'Playful Labrador puppy ready for a loving home. First vaccinations done. Comes with puppy starter kit.',
    image: 'https://readdy.ai/api/search-image?query=adorable%20labrador%20puppy%20sitting%20on%20soft%20blanket%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20cute%20baby%20dog%20warm%20lighting&width=600&height=600&seq=pet-pup1&orientation=squarish',
    seller: 'Sunshine Puppies',
    featured: true,
  },
  {
    id: 4,
    name: 'Daisy',
    category: 'puppies',
    breed: 'Beagle Puppy',
    age: '10 weeks',
    gender: 'Female',
    price: 700,
    location: 'Houston, TX',
    description: 'Sweet little Beagle puppy with big floppy ears. Very curious and loves to explore. Health checked.',
    image: 'https://readdy.ai/api/search-image?query=cute%20beagle%20puppy%20with%20big%20floppy%20ears%20sitting%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20adorable%20baby%20dog%20expression&width=600&height=600&seq=pet-pup2&orientation=squarish',
    seller: 'Pawfect Pups',
    featured: false,
  },
  {
    id: 5,
    name: 'Luna',
    category: 'cat',
    breed: 'Persian Cat',
    age: '1 year',
    gender: 'Female',
    price: 600,
    location: 'San Francisco, CA',
    description: 'Gorgeous Persian cat with silky white fur. Very calm and affectionate. Litter trained and spayed.',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20white%20persian%20cat%20with%20fluffy%20fur%20sitting%20elegantly%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20regal%20expression&width=600&height=600&seq=pet-cat1&orientation=squarish',
    seller: 'Royal Felines',
    featured: true,
  },
  {
    id: 6,
    name: 'Milo',
    category: 'cat',
    breed: 'British Shorthair',
    age: '2 years',
    gender: 'Male',
    price: 550,
    location: 'Seattle, WA',
    description: 'Charming British Shorthair with a plush gray coat. Independent yet loving. Fully vaccinated.',
    image: 'https://readdy.ai/api/search-image?query=handsome%20gray%20british%20shorthair%20cat%20sitting%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20calm%20dignified%20expression&width=600&height=600&seq=pet-cat2&orientation=squarish',
    seller: 'Cozy Cats',
    featured: false,
  },
  {
    id: 7,
    name: 'Coco',
    category: 'rabbit',
    breed: 'Holland Lop',
    age: '6 months',
    gender: 'Female',
    price: 120,
    location: 'Portland, OR',
    description: 'Adorable Holland Lop rabbit with floppy ears. Very gentle and loves to be held. Comes with cage.',
    image: 'https://readdy.ai/api/search-image?query=cute%20holland%20lop%20rabbit%20with%20floppy%20ears%20sitting%20on%20soft%20surface%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20adorable%20fluffy%20bunny&width=600&height=600&seq=pet-rab1&orientation=squarish',
    seller: 'Bunny Haven',
    featured: false,
  },
  {
    id: 8,
    name: 'Thumper',
    category: 'rabbit',
    breed: 'Mini Rex',
    age: '4 months',
    gender: 'Male',
    price: 95,
    location: 'Denver, CO',
    description: 'Soft and velvety Mini Rex rabbit. Very friendly and easy to handle. Perfect for families.',
    image: 'https://readdy.ai/api/search-image?query=cute%20mini%20rex%20rabbit%20with%20velvety%20fur%20sitting%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20soft%20fluffy%20bunny%20warm%20lighting&width=600&height=600&seq=pet-rab2&orientation=squarish',
    seller: 'Fluffy Bunnies',
    featured: false,
  },
  {
    id: 9,
    name: 'Kiwi',
    category: 'birds',
    breed: 'Cockatiel',
    age: '1 year',
    gender: 'Male',
    price: 180,
    location: 'Miami, FL',
    description: 'Beautiful Cockatiel that loves to whistle and sing. Hand-tamed and very social. Comes with cage.',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20yellow%20cockatiel%20bird%20perched%20on%20branch%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20colorful%20feathers%20warm%20lighting&width=600&height=600&seq=pet-bird1&orientation=squarish',
    seller: 'Feathered Friends',
    featured: true,
  },
  {
    id: 10,
    name: 'Sky',
    category: 'birds',
    breed: 'Budgerigar',
    age: '8 months',
    gender: 'Female',
    price: 45,
    location: 'Austin, TX',
    description: 'Vibrant blue Budgerigar. Very active and playful. Starting to mimic words. Great companion bird.',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20blue%20budgerigar%20parakeet%20bird%20perched%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20colorful%20small%20bird%20warm%20lighting&width=600&height=600&seq=pet-bird2&orientation=squarish',
    seller: 'Birdie World',
    featured: false,
  },
  {
    id: 11,
    name: 'Shelly',
    category: 'turtle',
    breed: 'Red-Eared Slider',
    age: '2 years',
    gender: 'Female',
    price: 75,
    location: 'Phoenix, AZ',
    description: 'Healthy Red-Eared Slider turtle. Active and loves swimming. Comes with tank and accessories.',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20red%20eared%20slider%20turtle%20on%20smooth%20rock%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20detailed%20shell%20pattern%20warm%20lighting&width=600&height=600&seq=pet-turt1&orientation=squarish',
    seller: 'Shell Paradise',
    featured: false,
  },
  {
    id: 12,
    name: 'Tank',
    category: 'turtle',
    breed: 'Box Turtle',
    age: '5 years',
    gender: 'Male',
    price: 110,
    location: 'Atlanta, GA',
    description: 'Beautiful Box Turtle with vibrant shell markings. Very docile and easy to care for. Healthy and active.',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20box%20turtle%20with%20colorful%20shell%20markings%20on%20natural%20surface%20in%20bright%20modern%20pet%20studio%20clean%20white%20background%20professional%20pet%20photography%20detailed%20patterns%20warm%20lighting&width=600&height=600&seq=pet-turt2&orientation=squarish',
    seller: 'Turtle Town',
    featured: false,
  },
];
